<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import articleApi from './api/article'

  export default {
    data() {
      return {}
    },
    created () {
      console.log('%c上海知加', 'text-shadow: 0 1px 0 #ccc,0 2px 0 #c9c9c9,0 3px 0 #bbb,0 4px 0 #b9b9b9,0 5px 0 #aaa,0 6px 1px rgba(0,0,0,.1),0 0 5px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.3),0 3px 5px rgba(0,0,0,.2),0 5px 10px rgba(0,0,0,.25),0 10px 10px rgba(0,0,0,.2),0 20px 20px rgba(0,0,0,.15);font-size:5em')
    }
  }
</script>
<style>
  .gl-bg-blue {
    background-color: #0077db;
  }

  .gl-txt-blue {
    color: #0077db;
  }

  .flex {
    display: flex;
  }

  .txt-grey {
    color: #aaa;
  }

  .txt-black {
    color: #333;
  }

</style>



// WEBPACK FOOTER //
// App.vue?45f71b56